@if (showBanner && notification) {
<div
  class="notification-toast"
  [class.ios]="isIOS"
  [@slideDown]
  (touchstart)="onTouchStart($event)"
  (touchmove)="onTouchMove($event)"
  (touchend)="onTouchEnd($event)"
  (click)="onNotificationClick()"
>
  <div class="toast-content">
    <div class="toast-text">
      <div class="toast-title">{{ notification.title }}</div>
      @if (notification.body) {
      <div class="toast-body">
        {{ notification.body }}
      </div>
      }
    </div>
  </div>
  @if (isDragging) {
  <div class="swipe-indicator">
    <ion-icon name="chevron-up" class="swipe-icon"></ion-icon>
  </div>
  }
</div>
}
